// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"oa_a bhb_a bhb_x","FilterForm__vgroup":"oa_b bhb_rp"};